<template>
	<div class="heads">
		<div class="big-center">
			<div class="center">
				<div style="width:500px;">
					<div class="top-left">
						<div class="logoname">欢迎来到很低批发，要批发，上很低批发 — 深圳市很低批网络科技有限公司</div>
					</div>
				</div>
				<div style="width:900px;">
					<div class="top-right">
						<span style="font-size:12px;color:#000;">{{shopName}}</span>
						<span @click="goHome()">首页</span>
						<span @click="goOrder('/order')">我的订单</span>
						<span @click="goAbute('/helpCenterList')">资讯中心</span>
						<!-- <span>
							<span onclick="qimoChatClick()" class="el-dropdown-link" style="color: #999;">
								联系客服
							</span>
						</span>
						<span >
							<el-dropdown  @command="handleCommand">
								<span class="el-dropdown-link" style="color: #999;">
									网站导航<i class="el-icon-arrow-down el-icon--right"></i>
								</span>
								<el-dropdown-menu slot="dropdown">
									<div style="width: 200px;display: inline-block;">
										<el-dropdown-item v-for="(item,index) in list" :key="index" :command="item.url" >{{item.name}}</el-dropdown-item>
									</div>
								</el-dropdown-menu>
							</el-dropdown>
						</span> -->
						<span v-if="userId" @click="quit()">退出登录</span>
					</div>
				</div>
			</div>
		</div>
		<div class="big-centers">
			<div class="center flex align-center justify-between">
				<div class="cons " @click="goHome()" style="cursor: pointer;">
					<img src="../assets/logo.png" />
				</div>
				<div class="cons cont">
					<div class="searchs" >
						<el-input placeholder="请输入关键字搜索" v-model="value" class="input-with-select">
							<el-button slot="append" icon="el-icon-search" @click="goAbute('/productList?title=' + value+'&shou=1')">搜索</el-button>
						</el-input>
					</div>
					<div class="search-list">
						<div v-for="(item,index) in data" :key="index" @click="goAbute('/productList?title=' + item+'&shou=1')">
							<!-- <span v-if="index==0" class="re bao">爆</span>
							<span v-if="index==1||index==2" class="re">热</span> -->
							{{item}}
						</div>
					</div>
				</div>
				<div class="Rclass cons">
					<div class="classList" @click="goAbute(1)">
						<div class="RlistNum">{{ dingdanCountList.count1 }}</div>
						<div class="RlistName">待付款</div>
					</div>
					<div class="classList" @click="goAbute(2)">
						<div class="RlistNum">{{ dingdanCountList.count2 }}</div>
						<div class="RlistName">待发货</div>
					</div>
					<div class="classList" @click="goAbute(3)">
						<div class="RlistNum">{{ dingdanCountList.count3 }}</div>
						<div class="RlistName">待收货</div>
					</div>
					<div class="classList" @click="goAbute(4)">
						<div class="RlistNum">{{ dingdanCountList.count4 }}</div>
						<div class="RlistName">待评价</div>
					</div>
				</div>
				<div class="cons ">
					<div class="myCars" @click="goShoppingCar('/shoppingCar')">
						<img class="carimg" src="../assets/head/card.png" />
						<span class="myCar">我的购物车</span>
						<span v-if="cartNum > 0" class="reddot tabbar__badge">
							{{cartNum}}
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Head',
		props: {
			data: [],
			queryInfo:''
		},
		data() {
			return {
				shopName: "",
				value: '',
				/* list: [{
						name: '热卖榜单',
						url: '/?index=1'
					},
					{
						name: '精选好物',
						url: '/?index=2'
					},
					{
						name: '每日上线',
						url: '/?index=3'
					},
					{
						name: '拼团购',
						url: '/?index=4'
					},
					// { name:'个人中心', url:'/order' },
				], */
				dingdanCountList: {
					count1: 0,
					count2: 0,
					count3: 0,
					count4: 0,
				},	//订单数量
				cartNum: 0
			}
		},
		mounted() {
			this.shopName = this.$cookie.get('shopName')
		},
		created() {
			this.getCartNum()
			this.getOrderCount()
			this.value = this.queryInfo
		},
		computed: {
			userId() {
				return this.$cookie.get('userId')
			},
		},
		methods: {
			// 订单数据
			getOrderCount() {
				this.$http({
					url: this.$http.adornUrl('/orders/count?userId=' + this.userId),
					method: 'get',
					params: this.$http.adornParams({})
				}).then(({data}) => {
					if (data.status === 0) {
						this.dingdanCountList = data.data;
					}
				})
			},
			getCartNum() {
				this.$http({
					url: this.$http.adornUrl('/selfCart/getNum?userId='+this.userId),
					method: 'get',
				}).then(({
					data
				}) => {
					if(data.status == 0) {
						this.cartNum = data.data.totalNum
					}
				})
			},
			goShoppingCar(url) {
				window.open('/#'+url, '_blank');
			},
			goHome() {
				this.$router.push({
					path: '/'
				})
			},
			goOrder(url) {
				window.open('/#'+url, '_blank');
				/* this.$router.push({
				 	path: url
				}) */
			},
			goAbute(url) {
				if(url>=1&&url<=4){
					window.open('/#/order?select=order&isOrderSel='+url, '_blank');
				}else{
					this.$cookie.set('children', '')
				//	window.open('/#'+url, '_blank');
					this.$emit('update-data',this.value)
					location.href = '/#'+url
				}
			},
			handleCommand(command) {
				this.$router.push({
					path: command
				})
			},
			sousuo() {
				if (this.value == '') {
					// this.$message('搜索内容不能为空')
				}
			},
			//退出登录
			quit() {
				//this.$store.commit('updateUserId', '')
				//this.$store.commit('updateRelationId', '')

				this.$cookie.set('uuid', '')
				this.$cookie.set('userId', '')
				this.$cookie.set('image_url', '')
				this.$cookie.set('nickName', '')
				this.$cookie.set('phone', '')
				this.$cookie.set("is_pass", '')

				this.$router.push({
					path: '/login'
				})

			}

		}
	}
</script>
<style scoped="scoped">
	.big-center {
		width: 100%;
		height: 24px;
		line-height: 24px;
		color: #999;
		font-size: 14px;
		background: #E6E6E6;
	}

	.center {
		width: 1400px;
		margin: 0 auto;
		display: flex;
	}

	.top-left {
		text-align: left;
	}

	.top-left div {
		display: inline-block;
	}

	.logoname {
		width: 100%;
	}

	.logins {
		width: 50%;
		text-align: center;
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-wrap: nowrap;
	}

	.logins span {
		color: #999;
		text-decoration: none;
	}

	.logins span:hover {
		color: #FF0D18;
		cursor: pointer;
	}

	.top-right {
		text-align: right;
	}

	.top-right span {
		display: inline-block;
		margin-left: 20px;
		color: #999;
		text-decoration: none;
	}

	.top-right span:hover {
		color: #FF0D18;
		cursor: pointer;
	}

	.big-centers {
		width: 100%;
		height: 120px;
		/* line-height: 120px; */
	}

	.big-centers .center .cons {
		display: inline-block;
	}

	.left {
		width: 25%;
		text-align: left;
	}

	.left img {
		position: relative;
		bottom: 6px;
	}

	.cont {
		width: 35%;
	}

	.searchs {
		padding-top: 26px;
	}

	.search-list {
		text-align: left;
		font-size: 14px;
		color: #999;
		margin-top: 10px;
	}

	.search-list div {
		display: inline-block;
		/* width: 16%; */
		cursor: pointer;
		margin-right: 10px;
	}

	.one {
		color: #FF0D18;
	}

	.one .re {
		display: inline-block;
		font-size: 12px;
		border: 1px solid #FF0D18;
		border-radius: 2px;
		background: #FFC1C1;
		padding: 0 2px;
		/* margin-right: 6px; */
	}

	.right {
		width: 18%;
		text-align: right;
		color: #FF2D55;
		font-size: 18px;
	}

	.myCars {
		color: #FF2D55;
		border: 2px solid #FF2D55;
		border-radius: 4px;
		width: 160px;
		text-align: center;
		height: 45px;
		line-height: 45px;
		cursor: pointer;
		position: relative;
	}

	.carimg {
		position: relative;
		top: 3px;
	}

	.el-input-group__append,
	.el-input-group__prepend {
		background: #FF2D55 !important;
		color: #fff !important;
		border: 1px solid #FF2D55 !important;
	}

	.Rclass {
		width: 25%;
	}

	.classList {
		display: inline-block;
		width: 23%;
		text-align: center;
		cursor: pointer;
	}

	.RlistNum {
		font-size: 24px;
		font-weight: 600;
	}

	.RlistName {
		color: #666666;
		font-size: 14px;
	}

	.myCar {
		font-size: 16px;
	}
	.myCars .reddot {
		position: absolute;
		left: 80%;
		top: -12px;
		right: 0;
		width: 26px;
		height: 26px;
		border-radius: 50%;
		background-color: #f43530;
		color: #fff;
		-webkit-transform: translate(40%);
		transform: translate(40%);
	}
	.tabbar__badge {
	    width: auto;
	    height: 26px;
	    line-height: 26px;
	    border-radius: 26px;
	    min-width: 26px;
	    padding: 0 2px;
	    font-size: 12px;
	    text-align: center;
	    white-space: nowrap;
	}

</style>



// WEBPACK FOOTER //
// src/components/head.vue